export default "__VITE_ASSET__6b32c85e__"